import React, { useContext } from 'react';
import { Context } from '../../../context/AppContext';
import useReviewAggregates from '../../../hooks/useReviewAggregates';
import { ReviewStars } from '../../Review';

const Reviews = ({ listingId }) => {
  const {
    media: { mobile },
  } = useContext(Context);

  const { reviewAggregates } = useReviewAggregates({
    listingId,
  });
  const { averageRating, count } = reviewAggregates || {};

  return count ? (
    <ReviewStars
      countText={`(${count})`}
      rating={averageRating}
      width={mobile ? 13 : 15}
    />
  ) : (
    ''
  );
};

export default Reviews;
